import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import GameContainer from './components/GameContainer';
import UIContainer from './components/UIContainer';
import SystemContainer from './components/SystemContainer';

const App: React.FC = () => {
  useEffect(() => {
    // ゲーム初期化処理
    document.title = '次元転生伝説 〜無限の可能性〜';
  }, []);

  return (
    <div className="app-container bg-gray-900 text-white min-h-screen">
      <Routes>
        <Route path="/" element={
          <div className="game-layout">
            <GameContainer />
            <UIContainer />
            <SystemContainer />
          </div>
        } />
        {/* 追加ルートはここに */}
      </Routes>
    </div>
  );
};

export default App; 